<template>
  <DropDownCardV2 class="mb-3" :default-open="defaultOpen">
    <template v-slot:label>
      <div class="p-4">
        <h5 data-test="tradeLinesToggle" class="m-0">{{ $t('message.credit.creditPlus.tradeLines') }}</h5>
      </div>
    </template>
    <template v-slot:dropdown>
      <div class="pt-0 pb-4 px-4">
        <div class="trade-line-container">
          <div v-if="tradeLines && tradeLines.length > 0">
            <div
              v-for="(item, index) in tradeLines"
              :key="index"
              class="trade-line border-top py-4"
              data-test="tradeLineItem"
            >
              <div class="left">
                <p class="mt-0 mb-1 text-dark small">
                  <b>{{ item.lenderName }}</b>
                </p>
                <p class="m-0 small">
                  {{ $t('message.credit.creditPlus.paymentAmount') }} {{ $n(item.paymentAmount, 'currency', langCode)
                  }}<br />
                  {{ $t('message.credit.creditPlus.originalBalance') }}
                  {{ $n(item.originalBalance, 'currency', langCode) }}<br />
                  {{ $t('message.credit.creditPlus.currentBalance') }} {{ $n(item.balanceOnTrade, 'currency', langCode)
                  }}<br />
                </p>
              </div>
              <mobialis-button
                v-if="showLoanButton"
                class="trade-line-button"
                width="w-auto"
                @click="loanSelected(item)"
                v-av-analytics-cta-interaction="{ elementText: loanButtonText, eventActionResult: 'open' }"
              >
                {{ loanButtonText }}
              </mobialis-button>
            </div>
          </div>
          <div v-else class="text-center mt-2 mb-5 text-muted small" data-test="noTradeLines">
            {{ $t('message.credit.creditPlus.noTradeLines') }}
          </div>
        </div>
      </div>
    </template>
  </DropDownCardV2>
</template>

<script>
import { mapGetters } from 'vuex';
import DropDownCardV2 from '@/components/DropDownCardV2.vue';

export default {
  name: 'LoanList',
  components: {
    DropDownCardV2,
  },
  data() {
    return {};
  },
  props: {
    tradeLines: {
      type: Array,
      default: () => [],
      required: true,
    },
    showLoanButton: {
      type: Boolean,
      default: () => false,
      required: false,
    },
    loanButtonText: {
      type: String,
      default: () => '',
      required: false,
    },
    defaultOpen: {
      type: Boolean,
      default: () => false,
      required: false,
    },
  },
  computed: {
    ...mapGetters({
      langCode: 'user/getLanguageCodeForNumericalInternationalization',
    }),
  },
  methods: {
    loanSelected(loanDetails) {
      this.$emit('loanSelected', loanDetails);
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'src/assets/scss/variables';

.trade-line-container {
  max-height: 300px;
  overflow: auto;
}

.trade-line {
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;

  .trade-line-button {
    align-self: center;
    justify-self: center;
  }
}

/* Mobile only*/
@media only screen and (max-width: $breakpoint-mobile) {
  .trade-line {
    flex-direction: column;

    .trade-line-button {
      margin: 20px 0 0;
      width: 100% !important;
    }
  }
}
</style>
